<ng-form #stepForm="ngForm">
    <input-wrap [messages]="checkoutFormComponent?.dataError"
                [canShowValidate]="!!(checkoutFormComponent?.dataError && checkoutFormComponent?.dataError['cvv'])">
        <input class="input"
               placeholder="CVV"
               type="text"
               pattern="[0-9]*"
               inputmode="numeric"
               name="sagepayPiSavedCardStatus"
               required
               data-cs-mask
               minlength="3"
               maxlength="4"
               autocomplete="off"
               [muiInput]="'CVV'"
               [(ngModel)]="cvc"
               [validateDataError]="checkoutFormComponent?.dataError"
               [validateDataErrorKey]="'cvv'" />
    </input-wrap>
</ng-form>
